
import {Component,Inject} from 'ng-metadata/core';
import {STATE_NAMES} from '../../../../primoExplore/primoExploreStates.module';
import {JournalsService} from "../../../../journals/journals.service";
import {getVid} from "../../../../appConfig/appConfigForward";
import {DatabasesService} from "../../../../journals/databases.service";
import {NewspapersService} from '../../../../newspapers/newspapers.service';
import {SearchService} from '../../../search.service';
import {SearchFieldsService} from '../../../search.fields.service';
import {getDefaultScope, getTab} from '../../../../appConfig/appConfigForward';

@Component({
selector: 'prm-back-to-library-search-button',
templateUrl: 'components/search/fullView/ngrs/backToLibrarySearchButton/back-to-library-search-button.html',
})



export class PrmBackToLibrarySearchButton{
    private backToBrowseLabel: string = 'nui.ngrs.backto.btn';

    constructor(@Inject('$stateParams')  private $stateParams:ng.ui.IStateParamsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private searchService: SearchService,
                private searchFieldsService: SearchFieldsService,
                private journalsService: JournalsService,
                private databasesService: DatabasesService,
                private newspapersService : NewspapersService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService) {
    }

    private navigateBackToSearchResults(){
        let state = STATE_NAMES.SEARCH;
        this.searchFieldsService.searchParams.search_scope= getDefaultScope();
        this.searchFieldsService.searchParams.tab= getTab(getDefaultScope()); 
        this.$state.go(state, this.searchFieldsService.searchParams , {reload: false});
    }

    private isBackToSearchRequired(){
        if(this.searchFieldsService.searchParams.search_scope === 'RapidXL'){
            return true;
        }
        return false;
    
    }

    get isBrowseMode(){
        return this.$stateParams['mode'] === 'browse';
    }

    get browseScope(){
        return this.$stateParams['browseScope'];
    }

    get browseState(){
        return STATE_NAMES.BROWSE_SEARCH;
    }

    get backToBrowseParams(){
        return {
            vid: getVid(),
            browseQuery: this.$stateParams['browseQuery'],
            browseScope: this.$stateParams['browseScope'],
            browseFirstTerm: this.$stateParams['browseFirstTerm'],
            innerPnxIndex: this.$stateParams['innerPnxIndex'],
            numOfUsedTerms: this.$stateParams['numOfUsedTerms'],
            fn: this.$stateParams['fn'],

        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/backToLibrarySearchButton/backToLibrarySearchButton.directive.ts